/**
 * Created by ChrisW on 08/02/2018.
 */
import Vue from 'vue'
import axios from '../axios'
import Vuex from 'vuex'

Vue.use(Vuex);
//import {marking} from './modules/marking'
//import {creating} from './modules/creating'
import {assess} from './modules/assess'
import {auth} from './modules/auth'
//import {find} from './modules/find'

var store = new Vuex.Store({
  modules: {
    //marking,
    //creating,
    assess,
    auth
    //find
  },
  state: {
    sidebar: true,
    questionMarkID: '',
    apiKey: '',
    geoserverLogin: '',
    currentTask: '',
    firebaseToken: '',
    firebaseUser: {},
    home: {
      lat: 51.505323,
      lng: -0.109863,
      zoom: 10
    },
    icons: {
      start: 'marker-green-48.png',
      end: 'marker-red-48.png',
      comment: 'comment-white.png',
      commentSelected: 'comment-teal.png',
      candidateStart: 'candidate-start.png'
    },
    questions: [],
    questionFilter: '',
    sessionLogged: false,
    userType: 'user'
  },
  mutations: {
    TOGGLE_SIDEBAR(state, payload) {
      if (typeof payload === 'boolean') {
        state.sidebar = payload;
      } else {
        state.sidebar = !state.sidebar;
      }
    },
    RECORD_SESSION(state) {
      state.sessionLogged = true;
    },
    SET_CUSTOMER_ID(state, payload) {
      Vue.set(state, 'questionMarkID', payload);
    },
    SET_API_KEY(state, payload) {
      Vue.set(state, 'apiKey', payload);
    },
    SET_GS_LOGIN(state, payload) {
      Vue.set(state, 'geoserverLogin', payload);
    },
    SET_QUESTION_FILTER(state, payload) {
      Vue.set(state, 'questionFilter', payload);
    },
    SET_QUESTIONS(state, payload) {
      state.questions = payload;
    },
    SET_TASK(state, payload) {
      state.currentTask = payload;
    },
    SET_USER_TYPE (state, payload){
      state.userType = payload;
    },
    storeNewQuestion(state, payload) {
      state.questions.push(payload);
    },
  },
  actions: {
    LOG_SESSION({state, commit}, email) {
      if (state.sessionLogged) {
        return;
      }
      return axios.post(process.env.VUE_APP_LOG_URL + '/sessions', {
        userid: email,
        org_id: email.split('@')[1],
        application: 'tat'
      }, {
        withCredentials: true
      }).then(() => {
        commit('RECORD_SESSION')
      })
    },
    LOG_EDIT({state, commit, rootGetters}, question) {
      let email = rootGetters['auth/GET_FIREBASE_USER'].email;
      return axios.post(process.env.VUE_APP_LOG_URL + '/tools', {
        user_id: email,
        org_id: email.split('@')[1],
        application: 'tat',
        tool: 'question_edit'
      }, {
        withCredentials: true
      })
    },
    REGISTER_USER({state, commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/register', {
          params: {
            email: payload.email,
            password: payload.password
          }
        }).then((res) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      })
    },
    FETCH_USER_DETAILS({state, commit}) {
      axios.get('/user/get-details').then((res) => {
        if (res.data.status === 'pass') {
          commit('SET_CUSTOMER_ID', res.data.customerID);
          commit('SET_API_KEY', res.data.apiKey);
          commit('SET_GS_LOGIN', res.data.geoserverAuth);
          commit('SET_USER_TYPE', res.data.userType);
        }
      }).catch((err) => {
        console.dir(err)
        console.log("Could not get details.")
      })
    },
    fetchQuestions({state, commit}) {
      console.log("TOKEN: " + state.firebaseToken)
      axios.post('/getquestions_all', {
          params: {
            userid: state.firebaseToken
          }
        }
      ).then((response) => {
        console.dir(response)
        if (response.data === "")
          response.data = [];
        console.dir(response.data);

        var processedQuestions = [];
        response.data.forEach((question) => {
          processedQuestions.push(question.question);
        });

        commit('SET_QUESTIONS', processedQuestions);
      }).catch((err) => {
        console.dir(err)
      })
    }
  },
  getters: {
    GET_QUESTIONMARK_ID(state) {
      return state.questionMarkID;
    },
    GET_API_KEY(state) {
      return state.apiKey;
    },
    GET_QUESTION_FILTER(state) {
      return state.questionFilter;
    },
    GET_FIREBASE_TOKEN(state) {
      return state.firebaseToken;
    },
    GET_TASK(state) {
      return state.currentTask
    },
    GET_FIREBASE_USER(state) {
      return state.firebaseUser
    },
    getQuestions(state) {
      console.log("store - getQuestions");
      if (!state.questionFilter)
        return state.questions;

      return state.questions.filter((question) => {
        console.dir(question)
        return question.linked_id.toString().indexOf(state.questionFilter) > -1 || question.description.toLowerCase().indexOf(state.questionFilter) > -1
      })
    },
    getIcons(state) {
      return state.icons;
    },
    GET_QUESTION_TITLE_BY_QMID: state => id => {
      let returnQ = null;
      state.questions.filter((question) => {
        console.log("QMID: " + id);
        console.log("LINKED ID: " + question.linked_id);
        console.log("Calculated ID: " + id % 100000000);
        if (Number(question.linked_id) % 100000000 === id % 100000000) {
          returnQ = question
        }
      });

      return returnQ !== null ? returnQ.description : null
    },
    getHomeLocation(state) {
      return state.home;
    },
    SIDEBAR(state) {
      return state.sidebar;
    },
    USER_TYPE (state) {
      return state.userType;
    }
  }
});
export default store;
